import { connect } from 'react-redux';
import { compose } from 'redux';
import { LN } from '../../../constants/measure';
import LNView from '../../LNView';
import withAvatar from '../../../common/avatar/withAvatar';
import AvatarView from '../../../common/avatar/avatarView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import selectors from '../../../rootSelectors';
import { fetchLNContent } from '../../LNActions';
import { blockScreen, unblockScreen } from '../../../common/screen/screenActions';
import { narratePracticeScreen, narrateScreenResponseClick } from './LNPracticeActions';
import { PRACTICE, QUESTIONS } from '../../../constants/assessmentItemType';
import { narrateStart, narrateReset } from '../../../common/audio/audioActions';
import { selectPossibleResponse } from '../../../common/questions/questionsActions';
import { goToCountdown } from '../../../common/navigation/navigationActions';

const mapStateToProps = (state) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    return {
        ...props,
        pageLayout: `${LN}`,
        isDataFetched: selectors.getIsLNDataFetched(state),
        stimulus: selectors.getLNStimulus(state, PRACTICE),
        selectedResponses: selectors.getMultiChoiceResponses(state),
        isButtonGridEnabled: selectors.getIsLNButtonGridEnabled(state),
        enabledResponses: selectors.getLNEnabledResponses(state),
        totalQuestions: selectors.getLNTotalQuestions(state, QUESTIONS),
        questionIndex: 0,
    };
};

const mapDispatchToProps = (dispatch) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchLNContent());
        },
        narrateScreen: async (stimulus) => {
            dispatch(blockScreen());
            dispatch(narrateStart());
            await dispatch(narratePracticeScreen(stimulus));
            dispatch(narrateReset());
            dispatch(unblockScreen());
        },
        selectResponse: (letter) => {
            dispatch(selectPossibleResponse(letter));
            dispatch(narrateScreenResponseClick());
        },
        onNext: () => {
            dispatch(goToCountdown(LN.ASSESSMENT, null));
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
});

const LNPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(LNView);

export default LNPracticeContainer;
